import * as React from "react";
import classnames from "classnames";
import { MediaQuery } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { FacetPickerHeader } from "./FacetPickerHeader.js";
/* empty css                 */
import { VariantsDrawer } from "../../../../../../../VariantsDrawer/modules/EcommContent/components/VariantsDrawer/VariantsDrawer.js";
const useMaxVisibleVariants = () => {
  const isTabletPortrait = MediaQuery.useIsTabletPortrait();
  if (isTabletPortrait) {
    return 10;
  }
  return 6;
};
const FacetPickerWithDrawer = ({
  onPick,
  itemComponent,
  facetTermFormatter: FacetTermFormatter,
  activeFacet,
  items,
  title,
  className,
  rightSlot,
  shouldShowFacetName,
  productType,
  isDrawerEnabled = false
}) => {
  const { getLabel } = useIntl();
  const ItemComponent = itemComponent;
  const maxVisibleVariants = useMaxVisibleVariants();
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false);
  const shouldShowDrawer = isDrawerEnabled && items.length > maxVisibleVariants;
  const visibleItems = shouldShowDrawer ? items.slice(0, maxVisibleVariants) : items;
  const showAllLabel = getLabel("products.variants.showAll");
  const handleDrawerVariantPick = (props) => {
    onPick(props);
    setIsDrawerOpen(false);
  };
  const handleDrawerOpenChange = (open) => {
    setIsDrawerOpen(open);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: classnames("facet-picker", className) }, /* @__PURE__ */ React.createElement(FacetPickerHeader, { rightSlot }, title), shouldShowFacetName && /* @__PURE__ */ React.createElement("div", { className: "facet-picker__info", "data-t": "facet-picker__info" }, activeFacet?.facetTerm), /* @__PURE__ */ React.createElement("div", { className: "facet-picker__facets", "data-t": "facet-picker-facets" }, /* @__PURE__ */ React.createElement(
    "ul",
    {
      className: classnames(`facet-picker__tiles`, {
        "facet-picker__tiles--single": visibleItems.length == 1,
        [`${className}__tiles`]: className
      }),
      "aria-label": title
    },
    visibleItems.map((item) => {
      const isActive = item.facetTerm === activeFacet?.facetTerm && item.sku === activeFacet?.sku;
      return /* @__PURE__ */ React.createElement(
        "li",
        {
          key: item.sku,
          className: classnames(`facet-picker__item`, {
            [`${className}__item`]: className
          }),
          "aria-current": isActive || void 0
        },
        /* @__PURE__ */ React.createElement(
          ItemComponent,
          {
            isActive,
            item,
            onPick,
            productType
          },
          FacetTermFormatter && /* @__PURE__ */ React.createElement(FacetTermFormatter, { facetTerm: item.facetTerm })
        )
      );
    })
  ), shouldShowDrawer && /* @__PURE__ */ React.createElement(
    VariantsDrawer,
    {
      title,
      showAllLabel,
      activeFacet,
      onPick: handleDrawerVariantPick,
      isOpen: isDrawerOpen,
      onOpenChange: handleDrawerOpenChange
    }
  ))));
};
export {
  FacetPickerWithDrawer
};
//# sourceMappingURL=FacetPickerWithDrawer.js.map
